import { graphql } from '@/graphql-setup'

export const IS_LOGGED_IN_QUERY = graphql(`
  query IsLoggedIn {
    isLoggedIn
  }
`)
